import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { AttributeRequirementsType } from './Enums'
/**
* Class OrderProductKeyAttributeSnapshot
*  Слепок данных ключевого атрибута товара
*/
export class OrderProductKeyAttributeSnapshot extends ActiveModel {

  /**
  * attributeId
  * Идентификатор атрибута<br>  */
  @ActiveField(0)
  attributeId: number = 0


  /**
  * type
  * словарь значений публикуется под именем `AttributeRequirementsType`  *   * Тип значения атрибута<br>  *   * - `String` Строка  *   * Строковый атрибут  * - `Bool` Логический  *   * Логический атрибут  * - `Integer` Целое число  *   * Атрибут со значением в виде целого числа  * - `Decimal` Десятичное число  *   * Атрибут со значением в виде десятичного числа  * - `Dict` Справочник  *   * Атрибут со значением из справочника  * - `File` Файл  *   * Атрибут со ссылкой на файл  *   */
  @ActiveField(AttributeRequirementsType.STRING)
  type: AttributeRequirementsType = AttributeRequirementsType.STRING


/**
  * name
  * Название атрибута<br>
  */
  @ActiveField('')
  name: string = ''


/**
  * value
  * Значение атрибута. Для атрибутов-словарей сохраняется именно значение, а не идентификатор<br>
  */
  @ActiveField('')
  value: string = ''


  /**
  * order
  * Порядковый номер атрибута среди других<br>  */
  @ActiveField(0)
  order: number = 0
}
